export enum QuotationOperationType {
  BKD = 'BKD',
  OPTION = 'OPTION',
  PREVENTIVO = 'PREVENTIVO',
  OPZIONAMENTO = 'OPZIONAMENTO',
  PAYMENT = 'PAYMENT'
}
